import { CustomSelectorType } from "./constants";
import CustomSelector from "./CustomSelector";

export default class CustomCheckbox extends CustomSelector {
    constructor(props) {
        super({
            type: CustomSelectorType.CHECKBOX,
            ...props,
        })
    }
}


// WEBPACK FOOTER //
// ./web/js/components/customCheckbox/CustomCheckbox.js